@if (!hideFooter) {
	<footer class="footer-admin mt-auto" [ngClass]="{ 'footer-light': !dark, 'footer-dark': dark }">
		<div class="container-fluid px-4">
			<div class="row gx-4">
				<div class="col-md-6 small">Copyright &copy; SilGov {{ year }}</div>
				<div class="col-md-6 text-md-end small">
					<a routerLink="/copyright/politics">Política de Privacidade</a>
					&middot;
					<a routerLink="/copyright/terms">Termos &amp; Condições</a>
				</div>
			</div>
		</div>
	</footer>
}
